
import { toast as sonnerToast, Toaster as SonnerToaster } from 'sonner';

export type ToastProps = {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'destructive';
  duration?: number;
};

// Export the toast function for direct usage
export function toast({ title, description, action, variant, duration }: ToastProps) {
  if (variant === 'destructive') {
    return sonnerToast.error(title, { description, action, duration });
  }
  
  return sonnerToast(title, { description, action, duration });
}

// Create a hook for compatibility with the existing codebase
export function useToast() {
  return {
    toast,
    // This is needed for compatibility with the toaster component
    toasts: [],
  };
}
